export class PMCCPASettings {constructor(c={}) { 
  Object.assign(this, {
    accordionsSpacing: { paddingLeft: 16, paddingRight: 16, paddingTop: 16, paddingBottom: 16 },
    accordionsFont: { fontSize: 13, fontWeight: '500', color: '#000000', fontFamily: 'arial, helvetica, sans-serif' },
    panelSpacing: { paddingLeft: 20, paddingRight: 20, paddingTop: 5, paddingBottom: 20 },
    panelFont: { fontSize: 13, fontWeight: '400', color: '#555555', fontFamily: 'arial, helvetica, sans-serif' },
    
    toggleType: 'basic',
    toggleColor: '#47d747',
    toggleActiveColor: '#ffffff',
    toggleText: 'On',
    toggleOffColor: '#cccccc',
    toggleOffActiveColor: '#ffffff',
    toggleOffText: 'Off',

    purposesText: 'Purposes',
    alphabetizeVendors: false,
    vendorsText: 'Site Vendors',
    vendorConsent: 'Relying on consent for:',
    searchText: 'Search Site Vendors',

    minHeight: { type: 'auto', value: 1 },
    maxHeight: { type: 'px', value: 400 },
    languages: {},
    selectedLanguage: '',

    viewAllText: 'View All',
    viewLessText: 'View Less',

  });
  Object.assign(this, c);
}}

export const PMCCPATypes = {
  height: {
    minHeight: { title: 'Min Scroll Height', type: 'Size' },
    maxHeight: { title: 'Max Scroll Height', type: 'Size' },
  },
  accordions: {
    accordionsSpacing: { title: 'Padding', type: 'Padding' },
    accordionsFont: { title: 'Font', type: 'Font' },
  },
  panel: {
    panelSpacing: { title: 'Padding', type: 'Padding' },
    panelFont: { title: 'Font', type: 'Font' },
  },
  settings: {
    alphabetizeVendors : { title: 'Sort Vendors Alphabetically?', type: 'Switch' },
    purposesText: { title: 'Purposes', type: 'InputLanguage' },
    vendorsText: { title: 'Vendors', type: 'InputLanguage' },
    vendorConsent: { title: 'Vendor Consent', type: 'InputLanguage' },
    searchText: { title: 'Search', type: 'InputLanguage' },
  },
  'toggle settings': {
    toggleType: { title: 'Type', type: 'ToggleType' },
    toggleColor: { title: 'ON Color', type: 'ColorPicker' },
    toggleActiveColor: { title: 'ON Active Text Color', type: 'ColorPicker' },
    toggleText: { title: 'ON Text', type: 'InputLanguage' },
    toggleOffColor: { title: 'OFF Color', type: 'ColorPicker' },
    toggleOffActiveColor: { title: 'OFF Active Text Color', type: 'ColorPicker' },
    toggleOffText: { title: 'OFF Text', type: 'InputLanguage' },
  }
};